import React from 'react';
import Snackbar from "@mui/material/Snackbar"
import Alert from '@mui/material/Alert';

export default function SnackbarEx({ color, message, open, close, position = "bottom" }) {

    return (
        <div>
            <Snackbar
                anchorOrigin={{ vertical: position, horizontal: 'center' }}
                open={open}
                autoHideDuration={5000}
                onClose={close}>
                <Alert onClose={close} severity={color}>{message}</Alert>
            </Snackbar>
        </div>
    );
};
